import React from 'react';
import { FiInfo, FiChevronDown } from 'react-icons/fi';

const ComplianceTrend = () => {
  // Chart coordinates mapped cleanly inside a responsive SVG box (width: 700, height: 120)
  const chartPoints = "0,48 116,30 233,12 350,66 466,30 583,66 700,12";
  const linePath = "M " + chartPoints;
  const areaPath = `${linePath} L 700,120 L 0,120 Z`;

  const dates = ["22 May", "23 May", "24 May", "25 May", "26 May", "27 May", "28 May"];
  const yAxisTicks = ["100%", "75%", "50%", "25%", "0%"];

  return (
    <div className="w-full bg-white border border-slate-100 rounded-2xl p-5 shadow-sm font-sans">
      
      {/* 1. Header Toolbar Row */}
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-1.5">
          <h3 className="text-sm font-bold text-slate-900">Compliance Score Trend</h3>
          <FiInfo className="text-slate-300 text-xs cursor-help shrink-0" />
        </div>
        
        {/* Dropdown Selector */}
        <div className="flex items-center gap-1 border border-slate-200 rounded-lg px-2.5 py-1 text-[11px] font-medium text-slate-600 bg-white cursor-pointer shadow-sm hover:bg-slate-50">
          <span>Last 7 days</span>
          <FiChevronDown className="text-slate-400 text-xs ml-0.5" />
        </div>
      </div>

      {/* 2. Main Visual Area Layout Grid */}
      <div className="grid grid-cols-12 gap-4 items-center">
        
        {/* Graph Zone Container (Takes up 10 columns) */}
        <div className="col-span-10 flex gap-2">
          
          {/* Y-Axis Labels */}
          <div className="flex flex-col justify-between text-[10px] font-medium text-slate-400 h-[120px] select-none text-right w-8 pr-1">
            {yAxisTicks.map((tick, i) => (
              <span key={i}>{tick}</span>
            ))}
          </div>

          {/* Graph Visual Node Block */}
          <div className="flex-1 flex flex-col justify-between">
            <div className="relative h-[120px] w-full">
              <svg viewBox="0 0 700 120" className="w-full h-full overflow-visible" preserveAspectRatio="none">
                <defs>
                  {/* Linear Gradient fill effect under the curve line */}
                  <linearGradient id="chartGradient" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#6366f1" stopOpacity="0.25" />
                    <stop offset="100%" stopColor="#6366f1" stopOpacity="0.00" />
                  </linearGradient>
                </defs>

                {/* Shaded Area Geometry Layer */}
                <path d={areaPath} fill="url(#chartGradient)" />

                {/* Main Purple Stroke Curve Path */}
                <path d={linePath} fill="none" stroke="#6366f1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />

                {/* Node Dot Points */}
                <circle cx="0" cy="48" r="3.5" fill="white" stroke="#6366f1" strokeWidth="1.5" />
                <circle cx="116" cy="30" r="3.5" fill="white" stroke="#6366f1" strokeWidth="1.5" />
                <circle cx="233" cy="12" r="3.5" fill="white" stroke="#6366f1" strokeWidth="1.5" />
                <circle cx="350" cy="66" r="3.5" fill="white" stroke="#6366f1" strokeWidth="1.5" />
                <circle cx="466" cy="30" r="3.5" fill="white" stroke="#6366f1" strokeWidth="1.5" />
                <circle cx="583" cy="66" r="3.5" fill="white" stroke="#6366f1" strokeWidth="1.5" />
                <circle cx="700" cy="12" r="3.5" fill="white" stroke="#6366f1" strokeWidth="1.5" />
              </svg>
            </div>

            {/* X-Axis Date Strings */}
            <div className="flex justify-between text-[10px] font-medium text-slate-400 mt-2 select-none">
              {dates.map((date, i) => (
                <span key={i} className="text-center transform translate-x-0">{date}</span>
              ))}
            </div>
          </div>

        </div>

        {/* Right Metric Summary block (Takes up 2 columns) */}
        <div className="col-span-2 text-right border-l border-slate-100 pl-4 h-[110px] flex flex-col justify-center">
          <p className="text-2xl font-bold text-slate-800 leading-none tracking-tight">92%</p>
          <p className="text-[11px] font-bold text-slate-500 mt-1.5 leading-none">Excellent</p>
          
          <div className="inline-flex items-center justify-end gap-0.5 text-emerald-600 mt-3 font-semibold text-[10px]">
            <span>↑ 8%</span>
          </div>
          <p className="text-[9px] text-slate-400 mt-0.5 leading-none">vs yesterday</p>
        </div>

      </div>

    </div>
  );
};

export default ComplianceTrend;
